import { ArchiveIcon, LogOutIcon, SettingsIcon, Share2Icon, UserPlusIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { ComingSoonBadge } from '@/components/atoms/coming-soon-badge.atom'
import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'

import { ChatWsDebugMenuItems } from './chat-ws-debug-menu-items.atom'

interface ChatHeaderActionsMenuItemsProps {
  onSettings?: () => void
  onArchive?: () => void
  onInvite?: () => void
  onLeave?: () => void
  isLeaveDisabled?: boolean
}

const IS_DEV = import.meta.env.DEV

export const ChatHeaderActionsMenuItems = ({
  onSettings,
  onArchive,
  onInvite,
  onLeave,
  isLeaveDisabled = false,
}: ChatHeaderActionsMenuItemsProps): ReactNode => (
  <>
    <DropdownMenuGroup>
      <DropdownMenuItem disabled className="chat-share-action">
        <div className="relative flex items-center gap-2">
          <Share2Icon className="size-4" />
          <span>Share chat</span>
          <ComingSoonBadge className="-top-2 -right-6" />
        </div>
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onInvite} className="chat-invite-action">
        <UserPlusIcon />
        Invite people
      </DropdownMenuItem>
    </DropdownMenuGroup>
    <DropdownMenuSeparator />
    <DropdownMenuGroup>
      <DropdownMenuItem onClick={onSettings}>
        <SettingsIcon />
        Chat settings
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onArchive}>
        <ArchiveIcon />
        Archive chat
      </DropdownMenuItem>
    </DropdownMenuGroup>
    <DropdownMenuSeparator />
    <DropdownMenuItem variant="destructive" onClick={onLeave} disabled={isLeaveDisabled}>
      <LogOutIcon />
      Leave chat
    </DropdownMenuItem>
    {IS_DEV && (
      <>
        <DropdownMenuSeparator />
        <ChatWsDebugMenuItems />
      </>
    )}
  </>
)
